import { supabase, DEMO_SCHOOL_SLUG } from "../supabase";
import type { School } from "../types";

interface SchoolRow {
  id: string;
  slug: string;
  name: string;
  icao: string | null;
  city: string | null;
  approval_ref: string | null;
  established: number | null;
  is_demo: boolean;
}

function mapSchool(r: SchoolRow): School {
  return {
    id: r.id,
    slug: r.slug,
    name: r.name,
    icao: r.icao,
    city: r.city,
    approvalRef: r.approval_ref,
    established: r.established,
    isDemo: r.is_demo,
  };
}

export async function getDemoSchool(): Promise<School> {
  const { data, error } = await supabase
    .from("schools")
    .select("id, slug, name, icao, city, approval_ref, established, is_demo")
    .eq("slug", DEMO_SCHOOL_SLUG)
    .single();
  if (error) throw error;
  return mapSchool(data as SchoolRow);
}

export async function getSchoolBySlug(slug: string): Promise<School | null> {
  const { data, error } = await supabase
    .from("schools")
    .select("id, slug, name, icao, city, approval_ref, established, is_demo")
    .eq("slug", slug)
    .maybeSingle();
  if (error) throw error;
  return data ? mapSchool(data as SchoolRow) : null;
}

export async function getSchoolById(id: string): Promise<School | null> {
  const { data, error } = await supabase
    .from("schools")
    .select("id, slug, name, icao, city, approval_ref, established, is_demo")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data ? mapSchool(data as SchoolRow) : null;
}
